/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Cmp_About_VerifiedInputs */

const en_cmp_about_verified = /** @type {(inputs: Cmp_About_VerifiedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Competitor facts checked ${i?.date}`)
};

const id_cmp_about_verified = /** @type {(inputs: Cmp_About_VerifiedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fakta pesaing dicek ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Competitor facts checked {date}" |
*
* @param {Cmp_About_VerifiedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cmp_about_verified = /** @type {((inputs: Cmp_About_VerifiedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmp_About_VerifiedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cmp_about_verified(inputs)
	return en_cmp_about_verified(inputs)
});